import merge from 'lodash-es/merge';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';
import get from 'lodash-es/get';
import pick from 'lodash-es/pick';
import each from 'lodash-es/each';
import omit from 'lodash-es/omit';

import getDisabledStyle from '../css/disabledStyle';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import { getDefaultControlStyle, getDefaultControl } from './radiobutton.defaults';
import Control from './control';

// const this.instance.radioGroups = {};

function uncheckAll(group, except) {
  // console.log('uncheckAll:');
  _.each(group, (rb, name) => {
    if (rb.gridSelectionSync) {
      return;
    }

    // console.log(' -> ' + name, rb.isChecked);
    if (name != except && rb.isChecked) {
      rb.isChecked = false;
      rb.render();
    }
    // console.log(' <- ' + name, rb.isChecked);
  });
}

export default class Radiobutton extends Control {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    this.addApi(this, 'text', () =>
      this._checkDataOption('text', get(this._controlOptions,'label.text','')),
      {formatter:'label.textFormatter'}
    );
  }

  onReady(){
    super.onReady();
    const control = this;
    const options = this._controlOptions;

    this.addTrigger('change',() => {
      if (control.gridSelectionSync) {
        return;
      }

      if (control.isChecked) {
        uncheckAll(this.instance.radioGroups[options.group], options.name);
      }

    });

    if (!this.instance.radioGroups[options.group]) {
      this.instance.radioGroups[options.group] = {};
    }

    this.instance.radioGroups[options.group][options.name] = control;
    if (control.isChecked && !control.gridSelectionSync) {
      uncheckAll(this.instance.radioGroups[options.group], options.name);
    }

    control.onChange.override = true;
  }

  renderElement() {
    const control = this;
    const options = this._controlOptions;
    const instance = this.instance;
    const path = this.path;
    const gridElement = options.gridElement;
    if(gridElement){
      this.grid = this.parentControl;
      control.gridSelectionSync =        
        this.grid.options.selectionMode &&
        this.grid.options.selectionMode !== 'none' &&
        this.grid.options.columns[gridElement.cellIndex].gridSelectionSync;
    }
    // if (!control.onChange.override) {
    //   const onChange = control.onChange;
    //   control.onChange = () => {
    //     if (control.gridSelectionSync) {
    //       return;
    //     }

    //     if (control.isChecked) {
    //       uncheckAll(this.instance.radioGroups[options.group], options.name);
    //     }

    //     onChange.apply(control);
    //   };

    //   if (!this.instance.radioGroups[options.group]) {
    //     this.instance.radioGroups[options.group] = {};
    //   }

    //   this.instance.radioGroups[options.group][options.name] = control;
    //   if (control.isChecked && !control.gridSelectionSync) {
    //     uncheckAll(this.instance.radioGroups[options.group], options.name);
    //   }

    //   control.onChange.override = true;
    // }

    if (control.gridSelectionSync) {
      // console.log('gridSelectionSync', gridElement.rowId, this.grid.value);
      if (this.grid.options.idForceUnique) {
        control.isChecked = (this.grid.value || []).indexOf(gridElement.rowId) !== -1;
      } else {
        control.isChecked = (this.grid.value || []).indexOf(gridElement.rowIndex) !== -1;
      }
    } else if (control.isChecked === undefined) {
      control.isChecked = options.isChecked || false;
    }

    if (!control.el) {
      // console.log('control has no el yet', control.el);

      control.el = getDefaultControl();
      if (!control.isLayoutMode) {
        control.el.addEventListener('mouseover', function() {
          control.isHover = true;
          control.render();
        });
        control.el.addEventListener('mouseout', function() {
          control.isHover = false;
          control.render();
        });

        control.el.addEventListener('click', function(ev) {
          if (control.gridSelectionSync) {
            return;
          }

          // console.log('this.instance.radioGroups', this.instance.radioGroups);
          // uncheckAll(this.instance.radioGroups[options.group], options.name);
          control.isChecked = true;
          control.render();
          // updateDataSourceParameter(control, options, instance);

          if (options.trigger) {
            if (!isFunction(options.trigger)) {
              console.error("radiobutton's click trigger should be a function", options.trigger);
            } else {
              options.trigger.apply(this, [options, instance, control, path, ev]);
            }
          }

          if (options.event) {
            if (!isString(options.event)) {
              console.error("radiobutton's click event should be a string", options.event);
            } else {
              instance.fire(
                options.event,
                pick(options, [
                  'name',
                  'isChecked',
                  'value',
                  'type',
                  'label',
                  'group',
                  'gridElement',
                ]),
                control,
                path,
                ev
              );
            }
          }

          control.doResetReload();

          // console.log('radio', control.isChecked, options.value);
        });
      }
    }

    // console.log('render radiobutton', options);
    var stylePatch = {};
    var bodyStylePatch = {};
    var iconStylePatch = {};
    var iconPathPatch = {};
    var labelStylePatch = {};
    var defaultStyle = getDefaultControlStyle(control);
    var iconEl = control.el.getElementsByClassName('icon')[0];
    var pathEl = iconEl.getElementsByTagName('path')[0];
    var labelEl;
    var bodyEl = control.el.getElementsByClassName('body')[0];
    var frameProps = [
      'top',
      'left',
      'right',
      'bottom',
      'margin',
      'position',
      'display',
      'width',
      'height',
    ];
    if (!options.label) {
      options.label = {};
    }

    if (!options.label.align) {
      options.label.align = 'right';
    }

    if (options.label.visible === undefined && control.text) {
      options.label.visible = true;
    }

    var labelIndex = options.label.align == 'left' || options.label.align == 'top' ? 0 : 1;
    var labels = control.el.getElementsByClassName('label');
    each(labels, function(label, i) {
      if (i == labelIndex) {
        labelEl = label;
      } else {
        label.style.display = 'none';
      }
    });
    // if (control.isLayoutMode) {
    //   labelEl.style.pointerEvents = 'none';
    // }
    //[2].innerHTML = options.label&&options.label.text||'';
    merge(stylePatch, defaultStyle.normal);
    merge(bodyStylePatch, defaultStyle.body.normal);
    merge(iconStylePatch, defaultStyle.icon.normal);
    merge(iconPathPatch, defaultStyle.iconPath.normal);
    merge(labelStylePatch, defaultStyle.label.normal);

    if (options.label.visible) {
      merge(bodyStylePatch, defaultStyle.body[options.label.align]);
      merge(labelStylePatch, defaultStyle.label[options.label.align]);
      merge(iconStylePatch, defaultStyle.icon[options.label.align]);
    }

    if (options.style && options.style.normal) {
      merge(stylePatch, pick(options.style.normal, frameProps));
      merge(iconStylePatch, omit(options.style.normal, frameProps));
    }

    merge(stylePatch, control.frameStyle);

    if (options.label.visible && options.label.style && options.label.style.normal) {
      merge(labelStylePatch, options.label.style.normal);
    }

    if (control.isHover) {
      merge(stylePatch, defaultStyle.hover);
      merge(bodyStylePatch, defaultStyle.body.hover);
      merge(iconStylePatch, defaultStyle.icon.hover);
      if (options.style && options.style.hover) {
        merge(stylePatch, pick(options.style.hover, frameProps));
        merge(iconStylePatch, omit(options.style.hover, frameProps));
      }

      if (options.label.visible) {
        merge(labelStylePatch, defaultStyle.label.hover);
        if (options.label.style && options.label.style.hover) {
          merge(labelStylePatch, options.label.style.hover);
        }
      }
    }

    if (control.isChecked) {
      merge(iconPathPatch, defaultStyle.iconPath.checked);
    }

    if (control.disabled) {
      merge(stylePatch, getDisabledStyle());
      if (options.style && options.style.disabled) {
        merge(stylePatch, options.style.disabled);
      }

      if (control.isLayoutMode) {
        delete stylePatch.pointerEvents;
      }
    }

    let scheme = lookAndFeel(options.lookAndFeel, stylePatch.height);
    // console.log('scheme', options.lookAndFeel, scheme);
    updateStyleByRef(
      [stylePatch, bodyStylePatch, iconStylePatch, iconPathPatch, labelStylePatch],
      scheme
    );

    // console.log('iconStylePatch', iconStylePatch);
    updateStyle(control.el, stylePatch, control.currentStyle);
    control.currentStyle = stylePatch;

    updateStyle(bodyEl, bodyStylePatch, control.currentBodyStyle);
    control.currentBodyStyle = bodyStylePatch;

    updateStyle(iconEl, iconStylePatch, control.currentIconStyle);
    control.currentIconStyle = iconStylePatch;

    updateStyle(pathEl, iconPathPatch, control.currentIconPathStyle);
    control.currentIconPathStyle = iconPathPatch;

    updateStyle(labelEl, labelStylePatch, control.currentLabelStyle);
    control.currentLabelStyle = labelStylePatch;
    if (options.label.visible) {
      labelEl.innerHTML = control.text || '';
    }

    return control.el;
  }
}
